import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=6efce734&scoped=true&"
import script from "./IconArrow.vue?vue&type=script&lang=js&"
export * from "./IconArrow.vue?vue&type=script&lang=js&"
import style0 from "./IconArrow.vue?vue&type=style&index=0&id=6efce734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efce734",
  null
  
)

export default component.exports